import { Component } from '@angular/core';

@Component({
  selector: 'lib-maintenance-template',
  templateUrl: './maintenance-template.component.html',
  styleUrls: ['./maintenance-template.component.scss'],
  standalone: false,
})
export class MaintenanceTemplateComponent {}
